function SpecialtySkeleton() {
  return (
    <div className="mb-2 w-full rounded-lg border p-2">
      <div className="flex items-center justify-between gap-4">
        <div className="h-4 w-72 animate-pulse rounded-md bg-gray-400" />
        <div className="flex items-center gap-2">
          <div className="h-4 w-4 animate-pulse rounded-md bg-gray-400" />
          <div className="h-4 w-20 animate-pulse rounded-md bg-gray-400" />
        </div>
      </div>
      <div className="mt-2 flex items-center gap-2">
        <div className="h-12 w-9 animate-pulse rounded-lg bg-gray-400" />
        <div className="w-full">
          <div className="flex items-center justify-between gap-4">
            <div>
              <div className="mb-2 h-4 w-72 animate-pulse rounded-md bg-gray-400" />
              <div className="mb-2 h-4 w-40 animate-pulse rounded-md bg-gray-400" />
            </div>
            <div className="h-6 w-20 animate-pulse rounded-md bg-gray-400" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SpecialtySkeleton;
